import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import ReactGA from "react-ga4";

import 'bootstrap/dist/css/bootstrap.min.css';
import MainDisplay from './blocks/mainDisplay';
import { HookProvider } from './blocks/hookContext';
import UsageHelp from './blocks/usageHelp';
import LanguageSwitcher from './blocks/languageSwitcher';
import RemoteViewer from './remote/RemoteViewer';
import './remote/remote.css';
const TRACKING_ID = "G-RWZQGKGL8F"; // OUR_TRACKING_ID
// Pairing links contain private credentials in their fragment.
if (!window.location.pathname.startsWith('/remote-control')) {
  ReactGA.initialize(TRACKING_ID);
}

function TeddyScreen({ lang, remote = false }) {
  return (
    <div className="fullform">
      <div className="titleform">
        <h1>Ready Teddy Go!</h1>
        <div className="headerActions">
          <LanguageSwitcher lang={lang} remote={remote} />
          <UsageHelp lang={lang} />
        </div>
      </div>
      <div className="mainWindow">
        <HookProvider>
          <MainDisplay lang={lang} remote={remote} />
        </HookProvider>
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/remote-control/view" component={RemoteViewer} />
        <Route exact path="/remote-control" render={({ location }) => {
          const requested = new URLSearchParams(location.search).get('lang');
          const lang = ['en', 'pl', 'it', 'es', 'el', 'lt'].includes(requested) ? requested : 'en';
          return <TeddyScreen lang={lang} remote />;
        }} />
        <Route path="/:lang" render={props => <TeddyScreen lang={props.match.params.lang} />} />
        <Redirect from="/" to="/en" />
      </Switch>
    </Router>
  );
}

export default App;
